import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const DayRangeChart = ({
  low,
  high,
  current,
  low_in_formet,
  high_in_formet,
  current_in_formet,
  chart_Title,
}) => {
  const percentage = ((current - low) / (high - low)) * 100;

  const chartData = {
    labels: [""],
    datasets: [
      {
        label: "Range",
        data: [100], // Full width
        backgroundColor: (context) => {
          const { chart } = context;
          const { ctx, chartArea } = chart;
          if (!chartArea) return null;

          const gradient = ctx.createLinearGradient(
            chartArea.left,
            0,
            chartArea.right,
            0
          );
          gradient.addColorStop(0, "#ff4d4d");
          gradient.addColorStop(0.5, "#cc9900");
          gradient.addColorStop(1, "#33cc33");
          return gradient;
        },
        order: 1,
        barThickness: 3,
      },
      {
        type: "bubble",
        label: "Marker",
        data: [
          {
            x: CheckPercentageValue(percentage),
            y: 0,
            r: 6,
          },
        ],
        backgroundColor: "black",
        order: 0,
      },
    ],
  };

  function CheckPercentageValue(percentage) {
    if (percentage === 0) {
      return 1;
    }

    if (percentage === 100) {
      return 99;
    }

    return percentage;
  }

  const chartOptions = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    scales: {
      x: {
        display: false,
        max: 100,
        min: 0,
      },
      y: {
        display: false,
        grid: { display: false },
      },
    },
  };

  return (
    <div style={{ minWidth: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
        }}
      >
        <div style={{ fontWeight: "bold" }}>{chart_Title}</div>
      </div>
      <table        
      >
        <tr>
        <td style={{ color: "red" }}>{low_in_formet}</td>
        {/*<div style={{ fontWeight: "bold" }}>{current_in_formet}</div>*/}
        <td style={{ color: "green", textAlign: "right" }}>{high_in_formet}</td>
        </tr>
      </table>
      <table        
      >
        <tr>
          <td style={{ color: "red", width: "10px" }}>
            <b>L</b>
          </td>
          <td style={{ width: "90%" }}>
            <Bar data={chartData} options={chartOptions} height={25} />
          </td>
          <td style={{ color: "green", width: "10px" }}>
            <b>H</b>
          </td>
        </tr>
      </table>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          style={{
            fontWeight: "bold",
            position: "relative",
            left:
              "calc(" +
              percentage +
              "%" +
              (percentage === 0 ? " + 0px" : " - 40px") +
              ")",
            marginTop: "-15px",
          }}
        >
          {current_in_formet}
        </div>
      </div>
    </div>
  );
};

export default DayRangeChart;
